// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3HHF8","rootCenter":"LoadMoreObserver_rootCenter__lppKJ","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__Xwy-2"};